module.exports = __webpack_public_path__ + "img/group5.018b7c47.png";